import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import PageHero from "../components/PageHero";
import { api, formatError } from "../lib/api";
import { toast } from "sonner";
import { BellRing, Trash2 } from "lucide-react";

// Moved out of Account page in iter 37 into a dedicated sidebar surface
// ("My Presence → Retail buyer alerts"). Same API endpoints as before —
// GET/POST/DELETE /api/alerts, GET /api/alerts/window-categories.
export default function BuyerAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [cats, setCats] = useState([]);
  const [pickCat, setPickCat] = useState("");

  const load = () => {
    api.get("/alerts").then((r) => setAlerts(r.data)).catch(() => {});
    api.get("/alerts/window-categories").then((r) => setCats(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const subscribe = async () => {
    if (!pickCat) return;
    try { await api.post("/alerts", { category: pickCat }); setPickCat(""); load(); toast.success("Subscribed"); }
    catch (e) { toast.error(formatError(e)); }
  };
  const unsubscribe = async (category) => {
    try { await api.delete("/alerts", { data: { category } }); load(); }
    catch (e) { toast.error(formatError(e)); }
  };

  return (
    <AppShell title="Retail buyer alerts">
      <div className="w-full" data-testid="buyer-alerts-page">
        <PageHero
          eyebrow="Buyer-window alerts"
          icon={BellRing}
          title={<>Never miss a <span className="text-grad">category review</span></>}
          subtitle="Subscribe to a NIQ category and we'll notify you (in-app + email) the next time a buyer window opens for it. This is how founders spot retail slots before their competitors do."
        />

        <div className="surface p-6">
          <div className="flex gap-2 flex-wrap">
            <select value={pickCat} onChange={(e) => setPickCat(e.target.value)} data-testid="buyer-alerts-pick"
              className="flex-1 min-w-[240px] rounded-md border border-shell-border bg-white px-3 py-2 text-sm">
              <option value="">Pick a category…</option>
              {cats.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
            <button onClick={subscribe} disabled={!pickCat} data-testid="buyer-alerts-subscribe"
              className="btn-amber disabled:opacity-60">
              Subscribe
            </button>
          </div>

          <div className="mt-6 grid gap-2">
            {alerts.length === 0 ? (
              <p className="text-sm text-muted-foreground">
                No subscriptions yet. Pick a category above to get notified when a buyer opens a review window.
              </p>
            ) : alerts.map((a) => (
              <div key={a.category} data-testid={`buyer-alerts-row-${a.category}`}
                className="flex items-center justify-between border border-shell-border rounded-md px-3 py-2 text-sm">
                <span className="font-semibold">{a.category}</span>
                <span className="text-xs text-muted-foreground">{a.upcoming} windows tracked</span>
                <button onClick={() => unsubscribe(a.category)} data-testid={`buyer-alerts-unsub-${a.category}`}
                  className="text-muted-foreground hover:text-destructive" title="Unsubscribe">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  );
}
